import { useEffect, useState } from "react";

import Box from "@/components/Box";
import { theme } from "@/core/theme";
import Menu, { Button } from "@/tpo/Menu";
import Stack from "@/tpo/Stack";
import ButtonV2 from "@/v2/Buttons";
import styled from "styled-components";

const ITEM_SX = {
  borderRadius: 0,
  justifyContent: "flex-start",
  gap: 10,
  padding: "5px 0px 5px 10px",
  height: "auto"
};

const DesktopNavStack = styled(Stack)`
  display: none;

  @media screen and (min-width: ${props => props.$desktopMinWidth}) {
    display: flex;
  }
`;

const MOBILE_NAV_TRIGGER_MAX_WIDTH = 353;

const MobileNavWrap = styled(Box)`
  display: flex;
  justify-content: center;
  width: 100%;

  @media screen and (min-width: ${props => props.$desktopMinWidth}) {
    display: none;
  }
`;

const MobileNavMenuWrap = styled(Box)`
  width: 100%;
  max-width: 100%;

  @media screen and (min-width: ${props => props.$mobileNavMenuMaxWidthFrom}) {
    max-width: ${MOBILE_NAV_TRIGGER_MAX_WIDTH}px;
  }
`;

export default function ResponsiveSideNavigation({
  links,
  desktopProps,
  mobileDropdownProps,
  desktopMinWidth = theme.breakpoints[3],
  mobileNavMenuMaxWidthFrom = theme.breakpoints.sm
}) {
  const [menuOpen, setMenuOpen] = useState(false);
  const activeLink = links.find(link => link.active);

  useEffect(() => {
    const desktopQuery = window.matchMedia(`(min-width: ${desktopMinWidth})`);
    const closeOnDesktop = () => {
      if (desktopQuery.matches) {
        setMenuOpen(false);
      }
    };

    closeOnDesktop();
    desktopQuery.addEventListener("change", closeOnDesktop);
    return () => desktopQuery.removeEventListener("change", closeOnDesktop);
  }, [desktopMinWidth]);

  return (
    <>
      <MobileNavWrap $desktopMinWidth={desktopMinWidth}>
        <MobileNavMenuWrap $mobileNavMenuMaxWidthFrom={mobileNavMenuMaxWidthFrom}>
          <Menu opened={menuOpen} onChange={setMenuOpen} trigger="hover">
            <Menu.Target>
              <Button open={menuOpen} fullWidth lineHeight="24px" paddingY="16px" paddingX="40px">
                {activeLink?.label}
              </Button>
            </Menu.Target>
            <Menu.Dropdown as={Stack} mt={2} py={40} px={40} zIndex={2} {...mobileDropdownProps}>
              {links.map(({ key, label, active, disabled, onClick, renderIcon }) => (
                <ButtonV2
                  leftIcon={renderIcon?.({ disabled })}
                  sx={{
                    borderLeft: active
                      ? `3px solid ${theme.colors.purple}`
                      : "3px solid transparent",
                    color: disabled ? theme.colors.carbon : theme.colors.dark,
                    textAlign: "left",
                    whiteSpace: "normal",
                    lineHeight: "1.8",
                    ...ITEM_SX
                  }}
                  key={key || label}
                  disabled={disabled}
                  onClick={onClick}
                >
                  {label}
                </ButtonV2>
              ))}
            </Menu.Dropdown>
          </Menu>
        </MobileNavMenuWrap>
      </MobileNavWrap>
      <DesktopNavStack
        $desktopMinWidth={desktopMinWidth}
        bg="white"
        borderRadius={5}
        pt={60}
        pb={80}
        px={40}
        mb="auto"
        minWidth={310}
        maxWidth={310}
        {...desktopProps}
      >
        {links.map(({ key, label, active, disabled, onClick, renderIcon }) => (
          <ButtonV2
            leftIcon={renderIcon?.({ disabled })}
            sx={{
              borderLeft: active ? `3px solid ${theme.colors.purple}` : "3px solid transparent",
              color: disabled ? theme.colors.carbon : theme.colors.dark,
              textAlign: "left",
              whiteSpace: "normal",
              lineHeight: "1.8",
              ...ITEM_SX
            }}
            key={key || label}
            disabled={disabled}
            onClick={onClick}
          >
            {label}
          </ButtonV2>
        ))}
      </DesktopNavStack>
    </>
  );
}

ResponsiveSideNavigation.defaultProps = {
  desktopProps: {},
  mobileDropdownProps: {}
};
